import * as e from "react";

var t = function () {
  var e = {
    name: "__LSM__",
    middleWares: [],
    persist: "action"
  },
      t = {};

  try {
    e.storageType = "undefined" != typeof sessionStorage ? window.sessionStorage : void 0;
  } catch (e) {}

  return {
    updateStore: function updateStore(n) {
      try {
        t = e.storageType && JSON.parse(e.storageType.getItem(e.name) || "") || n;
      } catch (e) {
        t = n;
      }
    },
    saveStore: function saveStore() {
      e.storageType && e.storageType.setItem(e.name, JSON.stringify(t));
    },

    get state() {
      return t;
    },

    set state(e) {
      t = e;
    },

    get options() {
      return e;
    },

    set options(t) {
      e = t;
    }

  };
}(),
    n = e.createContext(void 0),
    o = function o(_o) {
  var r = _o.children,
      s = e.useState(t.state),
      a = s[0],
      i = s[1];
  return e.useEffect(function () {
    "beforeUnload" === t.options.persist && (window.onbeforeunload = function () {
      return t.saveStore();
    }, t.options.storageType && t.options.storageType.removeItem(t.options.name));
  }, []), e.createElement(n.Provider, {
    value: {
      state: a,
      setState: i
    }
  }, r);
};

function r() {
  return r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }, r.apply(this, arguments);
}

function s(e, n) {
  n && (t.options = r({}, t.options, n)), "production" !== process.env.NODE_ENV && "undefined" != typeof window && (window.__LSM_NAME__ = t.options.name, window.__LSM_RESET__ = function () {
    return t.options.storageType && t.options.storageType.removeItem(t.options.name);
  }), t.updateStore(e);
}

function a(o) {
  var r = e.useContext(n),
      s = r.state,
      a = r.setState,
      i = e.useRef(Object.entries(o || {}).reduce(function (e, n) {
    var o;
    return Object.assign({}, e, ((o = {})[n[0]] = function (e, n) {
      return function (o, r) {
        "production" !== process.env.NODE_ENV && (window.__LSM_NAME__ = n.name), t.state = n(t.state, o), t.options.middleWares && (t.state = t.options.middleWares.reduce(function (e, t) {
          return t(e, n.name, o) || e;
        }, t.state)), (!r || !r.skipRender) && e(t.state), "action" === t.options.persist && t.saveStore();
      };
    }(a, n[1]), o));
  }, {}));
  return {
    actions: i.current,
    state: s,
    getState: e.useCallback(function () {
      return t.state;
    }, [])
  };
}

export { o as StateMachineProvider, s as createStore, a as useStateMachine };